// Dispatcher: matter → workspace component.
//
// Mapping:
//   immigration + subtype "asylum" or "removal-defense" → AsylumWorkspace
//   criminal                                            → CriminalWorkspace
//   anything else (including immigration non-asylum)    → RegistryWorkspace
//
// Per the v2 prototype, the deep workspaces fired for DL-MC7K2Q
// (immigration / asylum) and DL-AA8R4T (criminal / felony). Everything
// else fell through to the registry-driven placeholder.

import type { Client, Matter, PracticeArea } from "../../data/types";
import { RegistryWorkspace } from "./RegistryWorkspace";
import { AsylumWorkspace } from "./asylum/AsylumWorkspace";
import { CriminalWorkspace } from "./criminal/CriminalWorkspace";

interface Props {
  matter: Matter;
  client: Client | null | undefined;
  pa: PracticeArea | null;
  templateId: string | null;
}

const ASYLUM_SUBTYPES = new Set(["asylum", "removal-defense"]);

export function PracticeAreaDispatcher({ matter, client, pa, templateId }: Props) {
  if (matter.practiceArea === "criminal") {
    return <CriminalWorkspace matter={matter} client={client} pa={pa} templateId={templateId} />;
  }
  if (
    matter.practiceArea === "immigration" &&
    matter.subtype &&
    ASYLUM_SUBTYPES.has(matter.subtype)
  ) {
    return <AsylumWorkspace matter={matter} client={client} pa={pa} templateId={templateId} />;
  }
  return <RegistryWorkspace matter={matter} client={client} pa={pa} templateId={templateId} />;
}
